<template>
  <div class="goodList">
    <router-link
      :to="{ path: item.stock > 0 ? '/detail/' + item.id : $route.fullPath }"
      class="item acea-row row-between-wrapper"
      :class="item.stock > 0 ? '' : 'noStock'"
      v-for="(item, index) in goodList"
      :key="index"
    >
      <div class="pictrue">
        <img :src="item.image" class="image" />
        <img
          src="@assets/images/one.png"
          class="numPic"
          v-if="isSort === true && index === 0"
        />
        <img
          src="@assets/images/two.png"
          class="numPic"
          v-if="isSort === true && index === 1"
        />
        <img
          src="@assets/images/three.png"
          class="numPic"
          v-if="isSort === true && index === 2"
        />
      </div>
      <div class="underline">
        <div class="text">
          <div class="line1">{{ item.storeName }}</div>
          <div class="money font-color-red">
            <span class="num">{{ item.price }}</span>
            <span class="integral">积分</span>
          </div>
          <div class="vip-money acea-row row-middle">
            <!-- <div class="vip">
              {{ item.otPrice || 0 }}
              <span> 积分</span>
            </div> -->
            <span class="num">已售{{ item.sales }}{{ item.unitName }}</span>
          </div>
        </div>
      </div>
      <div v-if="item.stock <= 0" class="noselling">
        无&nbsp;货
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "GoodList",
  props: {
    goodList: {
      type: Array,
      default: () => []
    },
    isSort: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {};
  }
};
</script>
